import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-carajillo',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './carajillo.component.html',
  styleUrl: './carajillo.component.scss'
})
export class CarajilloComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.carajillo;
}
